import { useEffect, useState } from 'react'
import { readAuthConfig } from './authConfig'
import { exchangeCode } from './oidc'
import { storeSession, takeFlight } from './session'

/*
 * /auth/callback — completes the PKCE flow: validates state, exchanges the
 * code, stores the session, then returns to the app root. Errors render
 * honestly (no silent redirect into a half-authed state).
 */
export function AuthCallback() {
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search)
      const oauthError = params.get('error_description') || params.get('error')
      if (oauthError) {
        setError(oauthError)
        return
      }
      const code = params.get('code')
      const state = params.get('state')
      const flight = takeFlight()
      if (!code) {
        setError('No authorization code in the callback URL.')
        return
      }
      if (!flight || !state || state !== flight.state) {
        setError('Sign-in state mismatch — please start again from the login screen.')
        return
      }
      const config = readAuthConfig()
      if (!config || !config.hostedUiDomain) {
        setError('Auth is not configured in this build.')
        return
      }
      try {
        const tokens = await exchangeCode(config, {
          code,
          verifier: flight.verifier,
          redirectUri: flight.redirectUri,
        })
        storeSession(tokens)
        window.location.replace('/')
      } catch (e) {
        setError(e instanceof Error ? e.message : 'Token exchange failed.')
      }
    }
    void run()
  }, [])

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 20 }}>
      <div className="col" style={{ width: 420, gap: 12, textAlign: 'center' }}>
        {error ? (
          <>
            <h1 style={{ fontSize: 18 }}>Sign-in didn’t complete</h1>
            <p className="secondary" role="alert" style={{ fontSize: 13 }}>{error}</p>
            <a href="/" style={{ fontSize: 13 }}>Back to login</a>
          </>
        ) : (
          <p className="secondary" role="status" style={{ fontSize: 13 }}>Completing sign-in…</p>
        )}
      </div>
    </div>
  )
}
